import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SocietyCitySearchModal from './SocietyCitySearchModal';
import { getSocietyUrl } from '../../utils/urlHelpers';
import { STORAGE_GUEST_WELCOME_DISMISSED } from '../../hooks/useMainPageSocietyGate';
import { setGuestSocietyPreference } from '../../utils/guestSocietyPreference';

/**
 * First-visit welcome for guests on the home page: explore, log in, or pick a society (searchable list).
 */
const MainGuestWelcomeDialog = ({ open }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState('menu');
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem(STORAGE_GUEST_WELCOME_DISMISSED) === '1',
  );

  if (!open) {
    return null;
  }

  const dismiss = () => {
    sessionStorage.setItem(STORAGE_GUEST_WELCOME_DISMISSED, '1');
    setDismissed(true);
    setStep('menu');
  };

  const handleExplore = () => {
    dismiss();
  };

  const handleLogin = () => {
    dismiss();
    navigate('/login');
  };

  const handleSocietyPicked = (society) => {
    setGuestSocietyPreference(society);
    dismiss();
    navigate(getSocietyUrl(society));
  };

  if (!open || dismissed) {
    return null;
  }

  return (
    <>
      {step === 'menu' && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50"
          role="presentation"
        >
          <div
            className="bg-white rounded-2xl shadow-xl w-full max-w-md border border-gray-200 p-6"
            role="dialog"
            aria-modal="true"
            aria-labelledby="main-welcome-title"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 id="main-welcome-title" className="text-xl font-bold text-gray-900">
              Welcome
            </h2>
            <p className="text-gray-600 text-sm mt-2">
              Choose how you would like to use the community network.
            </p>
            <div className="mt-6 flex flex-col gap-3">
              <button
                type="button"
                onClick={() => setStep('pick')}
                className="w-full py-3 rounded-xl bg-emerald-600 text-white font-medium hover:bg-emerald-700 transition-colors"
              >
                Select a society
              </button>
              <button
                type="button"
                onClick={handleExplore}
                className="w-full py-3 rounded-xl border border-gray-300 text-gray-800 font-medium hover:bg-gray-50 transition-colors"
              >
                Explore the website
              </button>
              <button
                type="button"
                onClick={handleLogin}
                className="w-full py-3 rounded-xl border border-emerald-200 text-emerald-800 font-medium hover:bg-emerald-50 transition-colors"
              >
                Log in to become a member
              </button>
            </div>
          </div>
        </div>
      )}

      <SocietyCitySearchModal
        open={step === 'pick'}
        onClose={() => setStep('menu')}
        title="Select a society"
        onConfirm={handleSocietyPicked}
      />
    </>
  );
};

export default MainGuestWelcomeDialog;
